import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AppContext } from './AppContext';
import SPNListPageMediaItems from './SPNListPageMediaItems';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { useCache } from './CacheContext';

const CACHE_DURATION = 5000;

const ArtistsMediaListScreen = ({ onMoveMP }) => {
  const {
    playMedia,
    isPopupVisible, setIsPopupVisible,
    showMediaPopup,
    activePopupMedia,
    closePopup,
    httpArtworkUrl, setHttpArtworkUrl,
    isLoadingArtwork, setIsLoadingArtwork,
    popupSongArtworkUrl, setPopupSongArtworkUrl,
    popupVideoArtworkUrl, setPopupVideoArtworkUrl,
    showPopup, setShowPopup,
    handlePlayAndClose,
    isExpanded, setIsExpanded,
    userId, setUserId,
    setInitialExpandedAlbumAndSong,
    isLoadingNewPopup, setIsLoadingNewPopup,
    isLoadingExpand, setIsLoadingExpand,
    isLoadingSameUser, setIsLoadingSameUser,
    isLoadingProfilePicture, setIsLoadingProfilePicture,
    lastViewedMedia, setLastViewedMedia,
    showSameMediaPopup,
    setArtworkUri, centeredRelease, setCenteredRelease,
    hideExpandedAlbum, setHideExpandedAlbum,
    activeTab, setActiveTab,
    setInitiallySelectedItemId,
    isLoadingHideEA, setIsLoadingHideEA, currentUser, setUser,
    trackToView, setTrackToView, purchasedMedia, assetsSummary,
    userWallet, library, allSingles, allAlbums,
    musicVideos, userId2
  } = useContext(AppContext); 

  const navigate = useNavigate();
  const { state } = useLocation();
  const { artist } = state; // Destructure artist from state
  const [mediaItems, setMediaItems] = useState([]);

  const [selectedTab, setSelectedTab] = useState('Music');

  const firestore = getFirestore();




  const sortReleasesByTimestamp = (releases) => {
    const sortedReleases = [...releases].sort((a, b) => b.releaseTimestamp - a.releaseTimestamp);
    return sortedReleases;
  };

  const handlePressBegins = async (song) => {
    if (song?.isNFT || song?.editions) {
      const clonedSong = JSON.parse(JSON.stringify(song));
      navigate(`/dat/${song.id}`, { state: { clonedSong } });
    } else {
    const clonedSong = JSON.parse(JSON.stringify(song));
    navigate('/view-song', { state: { song: clonedSong } });
    }
  };

  const preparePopupData = (song, userData) => {
    let profileImageUrl = null;
    const itemUserData = [];

    profileImageUrl = userData?.profileImageUrl || null;

    let userAlbums = sortReleasesByTimestamp(userData.albums || []);
    let userSingles = sortReleasesByTimestamp(userData.singles || []);
    let userVideos = sortReleasesByTimestamp(userData.videos || []);

    let selectedAlbum = userAlbums.find(album => album.contentId === song.contentId) || null;
    let selectedSingle = userSingles.find(single => single.contentId === song.contentId) || null;
    let selectedVideo = userVideos.find(video => video.contentId === song.contentId) || null;

    const artworkUri = selectedVideo?.VideoThumbnailURL || (selectedAlbum || selectedSingle)?.ArtworkURL || song.ArtworkURL;
    setArtworkUri(artworkUri);

    let dimensions = [];
    if (song.isVideo) {
      dimensions = song.dimensions || [];
    }

    if (selectedAlbum && selectedAlbum.songs.length > 0) {
      setInitialExpandedAlbumAndSong(selectedAlbum, selectedAlbum.songs[0]);
      setCenteredRelease(selectedAlbum);
    } else if (selectedSingle && selectedSingle.length > 0) {
      setCenteredRelease(selectedSingle);
    } else if (selectedVideo) {
      setCenteredRelease(selectedVideo);
    }

    const songName = song.isVideo ? song.VideoName : song.SongName;

    return {
      url: song.SongURL,
      dimensions: dimensions,
      isVideo: song.isVideo,
      artistName: song.ArtistName,
      popupProfileImage: userData?.profileImageUrl,
      username: song.username,
      songName: songName,
      artworkUrl: artworkUri,
      accountType: userData.accountType,
      contentId: song.contentId,
      localArtworkURL: song?.localArtworkURL,
      userId: song.userId,
      isAlbum: song.isAlbum,
      albumName: selectedAlbum?.albumName || '',
      producers: song.producers,
      songwriters: song.songwriters,
      recordLabels: song.recordLabels,
      otherReleases: { albums: userAlbums, singles: userSingles, videos: userVideos },
      albumSongs: selectedAlbum?.songs || [],
      single: selectedSingle,
      video: selectedVideo,
      timestamp: new Date().getTime(),
      vocalDrop: userData.vocalDrop,
      voiceDropMuted: userData?.voiceDropMuted,
      bio: userData.bio,
      blurb: userData.blurb,
      location: userData.location,
      ScreenSKN: userData.ScreenSKN,
    };
  };





  const getCachedUserDoc = async (userId) => {
    let userDataCached = [];
    let userDataCachedNew = [];
    const now = new Date().getTime();

    if (!userDataCached || now - userDataCached.timestamp >= CACHE_DURATION) {
      
      const userDocRef = doc(firestore, 'users', userId);
      const userDocSnap = await getDoc(userDocRef);

      if (userDocSnap.exists()) {
        
        let freshUserData = userDocSnap.data();

        

        freshUserData = mergePurchasedMediaWithUserData(freshUserData, userId);

        userDataCachedNew = {
          ...freshUserData,
          profileImageUrl: freshUserData.profileImageUrl,
          timestamp: now
        };


      } else {
        console.error(`[getCachedUserDoc] No document found in Firestore for userId: ${userId}`);

        const userPurchasedMedia = purchasedMedia.filter(item => item.userId === userId);
        userDataCachedNew = {
          profileImageUrl: '',
          localProfileImageUrl: '',
          vocalDrop: '',
          bio: '',
          blurb: '',
          location: '',
          vocalDropMuted: false,
          ScreenSKN: [],
          accountType: 'Artist',
          albums: userPurchasedMedia.filter(item => item.isAlbum),
          singles: userPurchasedMedia.filter(item => !item.isAlbum && !item.isVideo),
          videos: userPurchasedMedia.filter(item => item.isVideo),
          timestamp: now
        };

        


      }
    }

    return userDataCachedNew;
  };

  const mergePurchasedMediaWithUserData = (userData, userId) => {
    const purchasedItems = purchasedMedia.filter(item => item.userId === userId);
    const mergeUniqueItems = (existingItems, newItems) => {
      newItems.forEach(item => {
        if (!existingItems.some(existingItem => existingItem.contentId === item.contentId)) {
          existingItems.push(item);
        }
      });
    };

    mergeUniqueItems(userData.albums || [], purchasedItems.filter(item => item.isAlbum));
    mergeUniqueItems(userData.singles || [], purchasedItems.filter(item => !item.isAlbum && !item.isVideo));
    mergeUniqueItems(userData.videos || [], purchasedItems.filter(item => item.isVideo));

    return userData; // Modified in-place
  };



 const fetchMediaByArtistName = async () => {
  const ownedIds = new Set(userWallet?.ownedDats?.map(i => i.id) || []);
  const cidOf = (x) => x?.contentId ?? x?.id;
  const inLibrary = (cid) => Array.isArray(library) && library.some(lib => lib.contentId === cid);

  // 1️⃣ DATS (NFT) from assetsSummary only
  const datsItems = (assetsSummary || [])
    .filter(a => ownedIds.has(a.id) && a.ArtistName === artist)
    .map(dat => ({
      ...dat,
      contentId: dat.id,
      isNFT: true
    }));

  // 2️⃣ Extra DATS from library—only if we find them in assetsSummary
  const existingIds = new Set(datsItems.map(i => i.contentId));
  const libraryExtras = (library || [])
    .map(libItem => (assetsSummary || []).find(a => a.id === libItem.contentId))
    .filter(asset => asset && !existingIds.has(asset.id) && asset.ArtistName === artist)
    .map(asset => ({
      ...asset,
      contentId: asset.id,
      isNFT: true
    }));

  // 3️⃣ Build a quick set of music video IDs to cross-check library
  const musicVideoIdSet = new Set((musicVideos || []).map(v => cidOf(v)));

  // 4️⃣ SINGLES (non-NFT) — match artist AND (in library OR owned by userId2)
  const singleItems = (allSingles || [])
    .filter(item => {
      const cid = cidOf(item);
      return (
        item.ArtistName === artist &&
        (inLibrary(cid) || item.userId === userId2) &&
        item.SongName &&
        item.ArtworkURL
      );
    })
    .map(item => ({
      ...item,
      contentId: cidOf(item),
      isNFT: false
    }));

  // 5️⃣ ALBUMS (non-NFT) — match artist AND (in library OR owned by userId2)
  const albumItems = (allAlbums || [])
    .filter(item => {
      const cid = cidOf(item);
      return (
        item.ArtistName === artist &&
        (inLibrary(cid) || item.userId === userId2)
      );
    })
    .map(item => ({
      ...item,
      contentId: cidOf(item),
      isNFT: false
    }));

  // 6️⃣ MUSIC VIDEOS — match artist AND (in library OR owned by userId2)
  const videoItems = (musicVideos || [])
    .filter(item => {
      const cid = cidOf(item);
      return (
        item.ArtistName === artist &&
        (inLibrary(cid) || item.userId === userId2)
      );
    })
    .map(item => ({
      ...item,
      contentId: cidOf(item),
      isNFT: false,
      isVideo: true
    }));

  // 6b️⃣ Library-based music videos for this artist that exist in musicVideos
  const libraryVideoOnly = (library || [])
    .filter(lib => lib.ArtistName === artist && musicVideoIdSet.has(lib.contentId))
    // exclude ones already captured in videoItems
    .filter(lib => !videoItems.some(v => v.contentId === lib.contentId))
    // hydrate from musicVideos state so the object shape matches
    .map(lib => (musicVideos || []).find(v => cidOf(v) === lib.contentId))
    .filter(Boolean)
    .map(item => ({
      ...item,
      contentId: cidOf(item),
      isNFT: false,
      isVideo: true
    }));

  // 7️⃣ Library-only items for this artist (no match elsewhere)
  const matchedIds = new Set([
    ...datsItems.map(i => i.contentId),
    ...libraryExtras.map(i => i.contentId),
    ...singleItems.map(i => i.contentId),
    ...albumItems.map(i => i.contentId),
    ...videoItems.map(i => i.contentId),
    ...libraryVideoOnly.map(i => i.contentId),
  ]);

  const libraryOnlyItems = (library || [])
    .filter(lib => lib.ArtistName === artist && !matchedIds.has(lib.contentId));

  // 8️⃣ Combine everything, dedupe (last one wins), and return
  const combined = [
    ...datsItems,
    ...libraryExtras,
    ...singleItems,
    ...albumItems,
    ...videoItems,
    ...libraryVideoOnly,
    ...libraryOnlyItems,
  ];

  const byId = {};
  combined.forEach(item => {
    byId[item.contentId] = item;
  });

  return Object.values(byId);
};


  useEffect(() => {
    const fetchMedia = async () => {
      const items = await fetchMediaByArtistName();
      setMediaItems(items);
    };

    fetchMedia();
  }, [artist, currentUser]);

  const hasMusic = mediaItems.some(item => item.isNFT === false);
const hasDats  = mediaItems.some(item => item.isNFT === true);

const showTabs = hasMusic && hasDats;

const filteredItems = showTabs
  ? (
      selectedTab === 'DATS'
        // DATS tab: only NFT items
        ? mediaItems.filter(item => item.isNFT === true)
        // Music tab: non-NFT and non-video
        : mediaItems.filter(
            item => item.isNFT === false && item.isVideo !== true
          )
    )
  : mediaItems;


  const capitalizeWords = (str) => {
    return str.replace(/\b\w/g, char => char.toUpperCase());
  };
  
  // Capitalized artist name
  const capitalizedArtist = capitalizeWords(artist);


  return (
    <div style={styles.fullScreen}>
      <div style={styles.container}>
        <div style={styles.headerContainer}>
          <h2 style={styles.headerText}>{capitalizedArtist}</h2>
        </div>

        {showTabs && (
          <div style={styles.tabContainer}>
            <button
              style={
                selectedTab === 'Music'
                  ? { ...styles.tab, ...styles.activeTab }
                  : styles.tab
              }
              onClick={() => setSelectedTab('Music')}
            >
              <span style={styles.tabText}>Music</span>
            </button>
            <button
              style={
                selectedTab === 'DATS'
                  ? { ...styles.tab, ...styles.activeTab }
                  : styles.tab
              }
              onClick={() => setSelectedTab('DATS')}
            >
              <span style={styles.tabText}>DATS</span>
            </button>
          </div>
        )}

        {filteredItems.map(item => (
          <SPNListPageMediaItems
            key={item.contentId}
            item={item}
            onPress={() => handlePressBegins(item)}
            isSelected={false}
            onDelete={() => {}}
          />
        ))}
      </div>

      <div style={styles.extraSpace} />
    </div>
  );
};
  
  const styles = {
    container: {
      height: '82%', // calculated from height - bottomAreaHeight
      zIndex: 1,
      paddingTop: '16px', // calculated from scrollAreaTopPadding
      paddingBottom: '18px', // calculated from bottomAreaHeight
      paddingHorizontal: '10px', // calculated from width * 0.042
      overflowY: 'scroll',
    },
    extraSpace: {
      height: '300px',
        },
    scrollContainer: {
      position: 'absolute',
      top: 0,
      width: '100vw',
      height: '82vh', // calculated from height - bottomAreaHeight
      zIndex: 10,
      overflow: 'visible',
    },
    fullScreenImage: {
      width: '100vw',
      height: '100vh',
      position: 'absolute',
      zIndex: 0,
    },
    fullScreenImageOverlay: {
      width: '100vw',
      height: '100vh',
      position: 'absolute',
      zIndex: 5,
    },
    fullScreen: {
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      overflow: 'hidden',
      position: 'relative',
    },
    headerContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      width: '100%',
      marginLeft: '20px',

    },
    headerText: {
      color: 'white',
      fontSize: '25px', // Adjusted font size
      fontWeight: 'bold',
      textAlign: 'center',
      fontFamily: 'brhendrix',
    },
    tabContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: '20px',
    },
    tab: {
      padding: '12px 32px',
      borderRadius: '8px',
      margin: '0 8px',
      backgroundColor: 'rgba(255,255,255,0.1)',
      border: 'none',
      cursor: 'pointer',
    },
    activeTab: {
      backgroundColor: 'rgba(255,255,255,0.25)',
    },
    tabText: {
      color: 'white',
      fontSize: '1rem',
      fontWeight: '600',
    },
  };

export default ArtistsMediaListScreen;
